import queryString from 'query-string'
import useSWR from 'swr'

import { stringifyParams } from 'utils/stringFormatting'

import * as T from 'types'

import { fetchWithToken } from '../fetchers'
import { getFetchErrorMessage } from './utils/errorMessageHelpers'

export const useMondayDeal = (id: string = '', queryParams: T.IGetQueryParams = {}) => {
  let apiEndpoint: string | null = null

  if (id) {
    apiEndpoint = `/monday-deals/${id}`
    if (Object.keys(queryParams).length) {
      const params = stringifyParams(['filter', 'populate'], queryParams) as T.IGetQueryParams
      apiEndpoint += `?${queryString.stringify(params)}`
    }
  }

  const response = useSWR<T.IMondayDeal | T.IServerError>(apiEndpoint, fetchWithToken)

  let mondayDeal: T.IMondayDeal | undefined

  if (response.data) mondayDeal = response.data as T.IMondayDeal

  const error = getFetchErrorMessage(response, 'mondayDeal')

  return {
    ...response,
    mondayDeal,
    error,
  }
}
